export interface Recipient {
    name: string;
    email: string;
}

const parseCSV = (csv: string): string[][] => {
    const lines = csv.trim().split('\n');
    return lines.map((line) => line.split(',').map((cell) => cell.trim()));
};

export const csvFileToRecipients = async (file: File): Promise<Recipient[]> => {
    return new Promise<Recipient[]>((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (event) => {
            try {
                const csv = event?.target?.result as string;
                const rows = parseCSV(csv);
                const header = rows[0];
                const data = rows.slice(1);

                // TODO(ParkingLot): Do we really need this validation?
                // If yes... Clearer messages about the error reason?
                if (
                    header.length < 2 ||
                    header[0] !== 'Recipient Name' ||
                    header[1] !== 'Recipient Email'
                ) {
                    reject(
                        'There was an error uploading your file. Please use the template provided.'
                    );
                    return;
                }

                const recipients: Recipient[] = [];

                for (let i = 0; i < data.length; i++) {
                    const name = data[i][0];
                    const email = data[i][1];

                    if (name && email) {
                        recipients.push({ name, email });
                    }
                }

                resolve(recipients);
            } catch (error) {
                reject(error);
            }
        };

        reader.onerror = (error) => {
            reject(error);
        };

        reader.readAsText(file);
    });
};
